/* eslint-disable */
import React, { useCallback, useRef } from 'react';
import WhySmeTargetHero from '../WhySmeTargetHero';
import WhySmeTargetReasons, {
  IWhySmeTargetReasonItem,
} from '../WhySmeTargetReasons';
import './index.less';

export type IWhySmeTargetItem = IWhySmeTargetReasonItem;

export interface IWhySmeTargetContentProps {
  title?: string;
  description?: string;
  items?: IWhySmeTargetItem[];
  backgroundImage?: string;
  id?: string;
  onComplete?: () => void;
}

const WhySmeTargetContent: React.FunctionComponent<IWhySmeTargetContentProps> = ({
  title,
  description,
  items = [],
  backgroundImage,
  id,
  onComplete,
}) => {
  const completedRef = useRef(false);
  const reasonsRef = useRef<HTMLDivElement>(null);

  const markComplete = useCallback(() => {
    if (completedRef.current) return;
    completedRef.current = true;
    onComplete?.();
  }, [onComplete]);

  const handleArrowClick = useCallback(() => {
    markComplete();
    reasonsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, [markComplete]);

  if (!items.length && !title && !description && !backgroundImage) return null;

  return (
    <div className="why-sme-target-content" id={id}>
      <WhySmeTargetHero
        title={title}
        description={description}
        backgroundImage={backgroundImage}
        onArrowClick={handleArrowClick}
      />
      <WhySmeTargetReasons
        ref={reasonsRef}
        items={items}
        className="why-sme-target-content-reasons"
        onComplete={markComplete}
      />
    </div>
  );
};

export default React.memo(WhySmeTargetContent);
